import React, { useEffect, useState } from "react";
import { Box, Typography, Card, Avatar, Stack } from "@mui/material";
import Slider from "react-slick";
import StarIcon from "@mui/icons-material/Star";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import axios from "axios";

// API URL
const API_URL = "https://ehankki.fi:8443/get-google-reviews";

// Slider ayarları
const sliderSettings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 4, // Geniş ekranda 3 yorum
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000,
  responsive: [
    { breakpoint: 1200, settings: { slidesToShow: 2 } }, // Tablet için 2 yorum
    { breakpoint: 768, settings: { slidesToShow: 1 } }, // Mobil için 1 yorum
  ],
};

// Timestamp'i okunabilir formata çeviren fonksiyon
const formatDate = (timestamp) => {
  if (!timestamp) return "Päivämäärä ei saatavilla";
  const date = new Date(timestamp * 1000);
  return date.toLocaleDateString("fi-FI", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
};

function GoogleReviews() {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchReviews = async () => {
      try {
        console.log("📡 API'ye istek gönderiliyor...");

        const response = await axios.get(API_URL);
        
        console.log("✅ API Yanıtı:", response.data); // API verisini kontrol et

        if (response.data && Array.isArray(response.data)) {
          setReviews(response.data);
        } else if (response.data.reviews) {
          setReviews(response.data.reviews); // Eğer veriler "reviews" key içinde geliyorsa
        } else {
          console.error("❌ Beklenmedik API formatı", response.data);
        }
      } catch (error) {
        console.error("🚨 API'den yorumlar alınırken hata oluştu:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchReviews();
  }, []);

  return (
    <Box sx={{ width: "100%", mt: "5%", textAlign: "center" }}>
      <Typography variant="h4" color="#37474f" sx={{ mb: "5%" }}>
        Asiakasarvostelut
      </Typography>

      {loading ? (
        <Typography variant="body2" color="textSecondary">
          🔄 Yorumlar ladataan...
        </Typography>
      ) : reviews.length > 0 ? (
        <Slider {...sliderSettings}>
          {reviews.map((review, index) => (
            <Box key={index} sx={{ px: 1 }}>
              <Card
                sx={{
                  width: "100%",
                  maxWidth: "80%",
                  mx: "auto",
                  p: 2,
                  borderRadius: "10px",
                  boxShadow: 6,
                  minHeight: "150px",
                }}
              >
                <Stack direction="row" spacing={2} alignItems="center">
                  {/* 📌 Eğer Base64 formatında profil fotoğrafı varsa kullan, yoksa varsayılan avatar */}
                  <Avatar
                    src={
                      review.profile_photo_url // Eğer Google'dan gelen URL varsa kullan
                        ? review.profile_photo_url
                        : review.profile_photo // Eğer veritabanından Base64 olarak geldiyse kullan
                        ? `${review.profile_photo}`
                        : "/default-avatar.png" // Eğer resim yoksa varsayılan avatar göster
                    }
                  />
                  <Box>
                    <Typography fontWeight="bold">{review.author_name}</Typography>
                    <Typography variant="caption">{formatDate(review.time)}</Typography>
                  </Box>
                </Stack>
                <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
                  {[...Array(review.rating)].map((_, i) => (
                    <StarIcon key={i} sx={{ color: "#FFD700", fontSize: "20px" }} />
                  ))}
                </Stack>
                <Typography variant="body2" sx={{ mt: 1 }}>
                  {review.text || "Ei kommenttia."}
                </Typography>
              </Card>
            </Box>
          ))}
        </Slider>
      ) : (
        <Typography variant="body2" color="textSecondary">
          ❌ Ei saatavilla arvosteluja.
        </Typography>
      )}
    </Box>
  );
}

export default GoogleReviews;
